import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { ParSection } from '@/features/reports/par'

/** Portfolio at risk and arrears ageing, as an addressable screen of its own. */
export function ReportsParPage() {
  return (
    <>
      <Link
        to="/reports"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All reports
      </Link>

      <PageHeader
        title="Portfolio at risk & arrears ageing"
        description="By ageing bucket, and the facility-level worklist behind any one of those buckets, worst first."
      />

      <ParSection />
    </>
  )
}
